<form [formGroup]="store.form" *ngrxLet="store.vm$ as vm">
  <ion-grid fixed="true">
    <ion-row class="form-row title">
      <ion-col class="edit-title terra-headline">
        <nty-title formControlName="title" placeholder="Title your Rock" />
        @if (hasRequiredError('title') && vm.isSubmitted) {
          <nty-form-error>Give your Rock a title.</nty-form-error>
        }
      </ion-col>
    </ion-row>
    <ion-row class="form-row">
      <ion-col class="edit-description terra-body">
        <nty-description
          formControlName="description"
          placeholder="Add a description {{ isOptional(store.form.controls['description']) ? '(optional)' : '' }}"
          [teamId]="store.form.value.teamId || undefined"
          [additionalTeamIds]="store.form.value.additionalTeamIds || undefined" />
      </ion-col>
    </ion-row>

    <ion-row class="form-row terra-body">
      <ion-col class="team-selector">
        <ion-label class="label">Team</ion-label>
        <nty-team-single-select
          [teams]="vm.teams"
          formControlName="teamId"
          [error]="hasRequiredError('teamId') && vm.isSubmitted"
          (selectedTeamIdChange)="store.onTeamIdChange($event)" />
        @if (hasRequiredError('teamId') && vm.isSubmitted) {
          <nty-form-error>Select team</nty-form-error>
        }
      </ion-col>
    </ion-row>
    <ion-row class="form-row terra-body">
      <ion-col class="additional-teams">
        <ion-label class="label">
          Shared Teams
          <nty-form-optional />
        </ion-label>
        <nty-team-multi-select
          placeholder="Choose other teams"
          ntyIcon="users-three--regular.svg"
          [teams]="store.getAdditionalTeams(vm.teams)"
          [error]="hasRequiredError('additionalTeamIds') && vm.isSubmitted"
          formControlName="additionalTeamIds" />
        @if (hasRequiredError('additionalTeamIds') && vm.isSubmitted) {
          <nty-form-error>Select team</nty-form-error>
        }
      </ion-col>
    </ion-row>
    <ion-row class="form-row terra-body">
      <ion-col class="owner">
        <ion-label class="label">Owner</ion-label>
        <nty-user-single-select
          [users]="store.teamUsers"
          formControlName="userId"
          [error]="hasRequiredError('userId') && vm.isSubmitted" />
        @if (hasRequiredError('userId') && vm.isSubmitted) {
          <nty-form-error>Select user</nty-form-error>
        }
      </ion-col>
    </ion-row>
    <ion-row class="form-row terra-body">
      <ion-col class="date-quarter-row flex-row">
        <div class="half-width-flex-item">
          <ion-label class="label terra-body">Due Date</ion-label>
          <nty-date-picker formControlName="dueDate" [maxDate]="vm.dateMax" [formatOptions]="vm.dateFormatOptions" />
        </div>
        <div class="half-width-flex-item">
          <ion-label class="label terra-body">Quarter</ion-label>
          <nty-select
            placeholder="Quarter"
            class="rock-quarter-select"
            formControlName="quarter"
            [showTriggerIcon]="true">
            <ion-icon triggerIcon src="assets/icons/calendar--regular.svg" class="icon" />

            <ng-container modalTitle>Quarter</ng-container>
            @for (
              rockQuarter of vm.rockQuarterOptions;
              track rockQuarter.quarter + '-' + rockQuarter.year;
              let index = $index
            ) {
              <nty-option
                [value]="`${rockQuarter.quarter}-${rockQuarter.year}`"
                [disabled]="index === 0"
                class="rock-filters-select-option">
                {{ rockQuarter.quarter }}
                @if (rockQuarter.quarter !== RockQuarter.none) {
                  FY {{ rockQuarter.year }}
                }
              </nty-option>
            }
          </nty-select>
        </div>
      </ion-col>
    </ion-row>
    <ion-row class="form-row terra-body">
      <ion-col class="status-row">
        <div class="half-width-flex-item status">
          <ion-label class="label terra-body">Status</ion-label>
          <nty-select
            placeholder="All Statuses"
            class="rock-filter-select"
            [showModalTitle]="true"
            [displaySelectionIcon]="true"
            formControlName="statusCode">
            <ng-container modalTitle>Status</ng-container>
            @for (rockDetail of vm.rockStatusDisplayOptions; track rockDetail) {
              <nty-option [value]="rockDetail.statusCode" class="rock-filters-select-option">
                <ion-icon
                  optionIcon
                  class="status-code-icon"
                  [ngClass]="rockDetail.className"
                  [src]="rockDetail.iconSrc" />
                {{ rockDetail.displayValue }}
              </nty-option>
            }
          </nty-select>
        </div>
      </ion-col>
    </ion-row>
    <ion-row class="form-row">
      <nty-attachments #attachments [deferUpload]="true" [parentType]="attachmentType" />
    </ion-row>
    <ion-row>
      <ion-col class="rock-level-code-row form-row">
        @if (vm.showDepartmentalRock || vm.showCompanyAndDepartmentalRock) {
          <ion-toggle
            formControlName="isDepartmentalRock"
            justify="start"
            class="terra-body-small half-width-flex-item"
            labelPlacement="end">
            <span class="toggle-label">Departmental Rock</span>
          </ion-toggle>
        }
        @if (vm.userCanEditRockLevelCode && (!vm.showDepartmentalRock || vm.showCompanyAndDepartmentalRock)) {
          <ion-toggle
            formControlName="isCompanyRock"
            justify="start"
            class="terra-body-small half-width-flex-item"
            labelPlacement="end">
            <span class="toggle-label">Company Rock</span>
          </ion-toggle>
        }
      </ion-col>
    </ion-row>
  </ion-grid>
</form>
